import * as Sentry from "@sentry/react";

export const sentryCapture = {
  exception: Sentry.captureException,
  message: Sentry.captureMessage,
};
